import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { axios } from "@/client/libs/axios";

type ProviderStatus = {
  id: string;
  name: string;
  isActive: boolean;
  mode: string | null;
};

const fetchProvidersStatus = async () => {
  const response = await axios.get<ProviderStatus[]>("/provider/status/all");
  return response.data;
};

export const useProvidersStatus = () => {
  const { data, isPending } = useQuery({
    queryKey: ["providersStatus"],
    queryFn: fetchProvidersStatus,
  });
  return { providersStatus: data, loading: isPending };
};

export const useSetProviderStatus = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, isActive }: { id: string; isActive: boolean }) =>
      axios.patch(`/provider/${id}/status`, { isActive }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["providersStatus"] });
      queryClient.invalidateQueries({ queryKey: ["providers"] });
    },
  });
};

export const useSetProviderMode = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, mode }: { id: string; mode: "live" | "sandbox" }) =>
      axios.patch(`/provider/${id}/mode`, { mode }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["providersStatus"] });
      queryClient.invalidateQueries({ queryKey: ["providers"] });
    },
  });
};
